/* label.tsx generated by @compiled/babel-plugin v0.28.8 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { element } from '../../core/elements';
import Text from '../text/Text';
import Formatters from '../utils/formatters';
import { getMaxContrast } from './utils';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _3 = "._1wyb1crf{font-size:9pt}";
const _2 = "._ect41wi2{font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif}";
const _ = "._1fjgnkob{text-anchor:middle}";
const labelTextStyles = null;
function ValueLabel(_ref) {
  let {
    x,
    y,
    color,
    formatter = Formatters.formatNumberAbbreviated,
    children
  } = _ref;
  if (!children) return null;
  if (typeof children === 'number' || typeof children === 'string') {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3]
      }), /*#__PURE__*/_jsx(Text, {
        x: x,
        y: y,
        style: {
          fill: getMaxContrast(color)
        },
        verticalAnchor: "middle",
        alignmentBaseline: "central",
        className: ax(["_1fjgnkob _ect41wi2 _1wyb1crf"]),
        children: formatter(children)
      })]
    });
  }
  return children;
}
const _ValueLabel = element(ValueLabel);
export { _ValueLabel as ValueLabel };